export function getRandomInt(max) {
  return Math.floor(Math.random() * max)
}
